import { CellFormatter } from '@tableau/data-catalog-client-components/lib/src/components/sharedDisplayGrid/types/SharedDisplayGridTypes';
import { DataGrid } from '@tableau/widgets-datagrid';

export function replaceColumnCellFormattersForDatabasesAndTables(mappedCellFormatters: Record<string, CellFormatter>, columns: DataGrid.Column[]) {
    columns.forEach(column => {
      if (mappedCellFormatters[column.name]) {
        column.cellFormatter = mappedCellFormatters[column.name].cellFormatter;
      }
    });
  }

export function replaceColumnCellFormattersForProjectPage(mappedCellFormatters: Record<string, CellFormatter>, columns: DataGrid.Column[]) {
    columns.forEach(column => {
      if (mappedCellFormatters[column.name] && isContentTypeColumn(column.name)) {
          column.cellFormatter = mappedCellFormatters[column.name].cellFormatter;
    }
    });
  }

/*
  For project page when content type is filtered to external assets, the VPC cell formatters are replaced with DC3 cell formatters.
  Name and DQW cell formatter, currently break the page so this function is used to skip those columns.
*/
function isContentTypeColumn(name: string) {
  switch(name) {

    case 'typeForCrass':
    case 'certification':
    case 'downstreamWorkbookCount':
    case 'downstreamDataSourcesCount':
    case 'columns':
    case 'database':
    case 'serverOrPath':
    case 'connectionTypeCrass':

      return true;
  }
  return false;
}
